import { useCallback, useEffect, useState } from 'react';
import { getPending, checkGate } from './notInMenuApi';
import { onDataChanged, onScreenResumed } from '../../utils/dataChangeSignal';

/**
 * How many dishes are Not in Menu, and would they block today's closing count?
 * Event-driven like useNotificationCount. On error the status is 'unknown' —
 * a gate-related number must never fall back to a reassuring 0.
 */
export function useNotInMenuCount() {
  const [state, setState] = useState({ status: 'loading', dishes: 0, blocking: false, blockingDishes: 0 });

  const reload = useCallback(async () => {
    const [p, g] = await Promise.all([getPending(), checkGate()]);
    if (!p.ok || !g.ok) { setState((s) => ({ ...s, status: 'unknown' })); return; }
    setState({
      status: 'ready',
      dishes: p.dish_count ?? (p.groups || []).length,
      blocking: g.blocking === true,
      blockingDishes: (g.dishes || []).length,
    });
  }, []);

  useEffect(() => {
    reload();
    const stopChanged = onDataChanged(reload);
    const stopResumed = onScreenResumed(reload);
    return () => { stopChanged(); stopResumed(); };
  }, [reload]);

  return { ...state, reload };
}

export default useNotInMenuCount;
